class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updateNarvarEDD()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    if (!newMedia) return
    const parent = newMedia.parentElement
    parent.prepend(newMedia)
    window.setTimeout(() => {
      parent.scroll(0, 0)
    })
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll('[data-product-form]')
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      const estShippingInput = productForm.querySelector('input#estimated-shipping')

      if(estShippingInput && this.currentVariant.metafields.pre_order.estimated_ship_date !== '') {
        estShippingInput.value = this.currentVariant.metafields.pre_order.estimated_ship_date
        estShippingInput.setAttribute('name', 'properties[Estimated Shipping]');
      } else {
        estShippingInput.removeAttribute('name');
      }
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  renderProductInfo() {
    $('#BIS_trigger.new-bis-btn').hide()
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const stickyId = `sticky-price-${this.dataset.section}`
        const stockId = `stock-message-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const stickyDestination = document.getElementById(stickyId)
        const stockDestination = document.getElementById(stockId)
        const source = html.getElementById(id)
        const stickySource = html.getElementById(stickyId)
        const stockSource = html.getElementById(stockId)

        if (source && destination) destination.innerHTML = source.innerHTML
        if (stickySource && stickyDestination)
          stickyDestination.innerHTML = stickySource.innerHTML
        if (stockSource && stockDestination)
          stockDestination.innerHTML = stockSource.innerHTML

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')

        this.toggleAddButton(
          !this.currentVariant.available ||
            this.currentVariant.available == 'false',
          window.variantStrings.soldOut
        )
        if(this.dataset.hasInseam == "true" && this.dataset.hasInseamPosition != "false"){
          var inseamIndex = parseInt(this.dataset.hasInseamPosition) - 1;
          var sizeIndex = inseamIndex -1;
          var size = this.currentVariant.options[sizeIndex];
          this.variantData.forEach((v) => {
            if(v.options[sizeIndex] == size){
              if(v.available == "true"){
                this.querySelector('[name="Inseam"][value="'+v.options[inseamIndex]+'"] + label').removeAttribute('data-disabled')
              }
              else{
                this.querySelector('[name="Inseam"][value="'+v.options[inseamIndex]+'"] + label').setAttribute('data-disabled', "")
              }
            }
          });

        }
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButtons = document.querySelectorAll('product-form [name="add"]')
    const buyNowBtns = document.querySelectorAll('product-form [name="buy-now"]')
    const preOwnedBtn = document.querySelectorAll('product-form #Preloved_trigger')

    if (!addButtons) return

    if (disable) {
      addButtons.forEach((button) => {
        button.setAttribute('disabled', true)
      })

      buyNowBtns.forEach((button) => {
        button.classList.add("hidden")
      })

      preOwnedBtn.forEach((button) => {
        button.setAttribute('disabled', true);
        button.style.opacity = 0.5
      })

      if (text && !this.classList.contains('js-preorder'))
        addButtons.forEach((button) => {
          button.textContent = text
        })

      document.querySelectorAll('#BIS_trigger').forEach(bisTrigger => bisTrigger.style.display = 'block')
    } else {
      addButtons.forEach((button) => {
        button.removeAttribute('disabled')
      })

      buyNowBtns.forEach((button) => {
        button.classList.remove('hidden');
      })

      preOwnedBtn.forEach((button) => {
        button.removeAttribute('disabled');
        button.style.opacity = 1;
      })

      if (!this.classList.contains('js-preorder')) {
        addButtons.forEach((button) => {
          button.textContent = window.variantStrings.addToCart
        })
      }

      document.querySelectorAll('#BIS_trigger').forEach(bisTrigger => bisTrigger.style.display = 'none')
    }

    this.updateShippingEstimation()

    if (!modifyClass) return
  }

  updateShippingEstimation() {
    const $estimated_date = document.querySelector(
      '.product__shipping-eta .js-shipping-estimation'
    )
    if ($estimated_date) {
      $estimated_date.textContent =
        this.currentVariant.metafields.pre_order.estimated_ship_date
    }
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  updateNarvarEDD() {
    const narvarContainer = document.querySelector('narvar-edd');
    if(narvarContainer) {
      narvarContainer.setAttribute('product-data', JSON.stringify({
        ...narvarContainer['product-data'],
        sku: this.currentVariant.sku,
        price: this.currentVariant.price,
      }));
    }
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
    this.showUnavailable()
  }

  showUnavailable() {
    const variants = this.getVariantData()
    variants.map((variant, variantIndex) => {
      if (variant.available) return
      variant.options.map((optionValue, valuesIndex) => {
        const optionsToDisable = Array.from(
          this.querySelectorAll(`input[value="${optionValue}"]`)
        )
        if (!optionsToDisable.length) return
        optionsToDisable.map((optionInput, inputsIndex) => {
          const optionName = optionInput.name
          const selector = `${this.dataset.section}-${optionName}-${variantIndex}`
          const radioToDisable = this.querySelector(`#${selector}`)
          const stickyRadioToDisable = document.querySelector(
            `button[data-target="${selector}"]`
          )

          if (radioToDisable) {
            this.querySelector(`#${selector}`).disabled = true
          }

          if (stickyRadioToDisable) {
            stickyRadioToDisable.disabled = true
          }
        })
      })
    })
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      // Get value and update fieldset label
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      )
      const checkedRadioValue = checkedRadio.value
      checkedRadio.parentNode.querySelector('.js-value').innerHTML =
        checkedRadio.value

      // Update sticky variants
      const stickyRadio = document.querySelector(
        `button[data-target="${checkedRadio.id}"]`
      )
      if (stickyRadio) {
        stickyRadio.click()
      }
      return checkedRadio.value
    })
  }
}

customElements.define('variant-radios', VariantRadios)